import styled from 'styled-components'
import { colors, device } from 'Styled/variables'
import { Space } from 'antd'

export const Container = styled.form`
  display: flex;
  flex-direction: column;

  button,
  textarea {
    font-family: 'Segoe UI';
  }
`

export const SectionTitle = styled.h5`
  margin: 40px 0 16px 0;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  color: ${colors.mainText};
`

export const TextArea = styled.textarea`
  height: 120px;
  padding: 13px 16px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.mainText};
  border: 1px solid ${colors.greyStroke};
  border-radius: 8px;
  outline: none;
  resize: none;

  &::placeholder {
    color: ${colors.greyTextWhiteBg};
  }
`

export const StyledSpace = styled(Space)`
  .ant-radio-wrapper {
    margin-bottom: 19px;

    span {
      font-size: 14px;
      font-weight: 400;
      color: ${colors.mainText};
    }
    .ant-radio-inner::after {
      background-color: ${colors.green};
    }
    .ant-radio-checked .ant-radio-inner {
      border-color: ${colors.green};
    }
  }
  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: none;
  }
  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: ${colors.green};
  }
`

export const ButtonsContainer = styled.div`
  padding: 30px 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${device.mobileMax} {
    flex-direction: column-reverse;
  }
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9.5px 40px;
  height: 40px;
  font-size: 14px;
  border-radius: 27px;
  color: ${colors.white};
  background-color: ${({ disabled }) =>
    disabled ? colors.greyTextBlackBg : colors.green};
  border: 1px solid
    ${({ disabled }) => (disabled ? colors.greyTextBlackBg : colors.green)};
`

export const ButtonSimple = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 16px;
  padding: 0;
  font-size: 14px;
  color: ${colors.mainText};
  background: transparent;
  border-bottom: 1px dashed ${colors.mainText};

  @media ${device.mobileMax} {
    margin-top: 16px;
  }
`

export const Warning = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
`

export const WarningIcon = styled.img`
  margin-right: 8px;
  width: 16px;
  height: 14px;
`

export const WarningText = styled.span`
  font-size: 14px;
  color: ${colors.messegesYellow1};
`

export const HiddenPlaylistsContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const HiddenPlaylistsText = styled.span`
  font-size: 14px;
  color: ${colors.greyTextWhiteBg};
`

export const HiddenPlaylistsIcon = styled.img`
  margin-right: 8px;
  width: 16px;
`
